// data { currency: '', amount: ''}
import axios from 'axios';
import { Cloudinary } from '@cloudinary/url-gen';
import { LoadingOutlined } from '@ant-design/icons';


export const currencyFormatter = (amount = 0, currency = "INR") => {
  return amount.toLocaleString("en-IN", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2, // Ensures two decimal places
    maximumFractionDigits: 2,
  }) // Remove minor units (e.g., 0.00)
};

const CURRENCY_KEY = "currency";
const MULTIPLIER_KEY = "currencyMultiplier";

export const currencyFormatterWithMultiplier = (amount = 0) => {
  const currency = localStorage.getItem(CURRENCY_KEY);
  const multiplier = parseFloat(localStorage.getItem(MULTIPLIER_KEY));

  if (!currency || !multiplier) {
    return <LoadingOutlined />;
  }
  console.log(multiplier);
  
  const convertedAmount = amount * multiplier;

  return convertedAmount.toLocaleString("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: convertedAmount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  });
};



export const cloudinaryConverter = (url) => {
  const cld = new Cloudinary({
    cloud: {
      cloudName: 'demo'
    }
  });

  return url
}

export const QuillModules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link', 'image', 'video'],
    ['clean'],
    ['code-block']
  ]
};

export const QuillFormats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'link',
  'image',
  'video',
  'code-block'
];